// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-footer.nkl-deck-footer {
  position: relative;
  padding: 1rem 1rem 3rem;
  text-align: center;
  color: #fff;
  background: #363e42;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links-container {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links-container.nkl-deck-footer-loading {
  opacity: 0;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links {
  margin: 1rem 0;
  padding: 0;
  list-style-type: none;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links a {
  color: #fff;
  text-decoration: underline;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-copyright {
  margin: 1rem 0;
  font-size: 12px;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loading {
  visibility: hidden;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader.nkl-deck-footer-loading {
  display: block;
  visibility: visible;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader .nkl-deck-footer-spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 48px;
  height: 48px;
  transform: translate(-50%, -50%);
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader .nkl-deck-footer-spinner {
  width: 100%;
  fill: #fff;
  opacity: 0.5;
  animation: spin 0.5s infinite linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
